import classNames from './Footer.module.scss';
import { useTranslation } from 'react-i18next';
import iconBritannica from '@/assets/svg/footerBritannica2.svg';
import copyright from '@/assets/svg/copyright.svg';
import classes from 'classnames';
import StoreButtons from '@/components/StoreButtons/StoreButtons';
import SVG from 'react-inlinesvg';

interface FooterProps {
  fromLogin?: boolean;
  disableSticky?: boolean;
  className?: string;
}
const Footer = ({ fromLogin = false, disableSticky = false, className }: FooterProps) => {
  const { t } = useTranslation();

  const LinkList = [
    {
      path: 'https://corporate.britannica.com/contact',
      name: 'Support',
      order: 1,
    },
    {
      path: 'https://britannicaeducation.com/solutions/',
      name: 'Britannica products',
      order: 2,
    },
    {
      path: 'https://britannicaeducation.com/about-britannica-education',
      name: 'About us',
      order: 3,
    },
    {
      path: 'https://corporate.britannica.com/privacy.html',
      name: 'Privacy policy',
      order: 4,
    },
    {
      path: 'https://corporate.britannica.com/termsofuse.html',
      name: 'Terms of service',
      order: 5,
    },
  ];

  return (
    <div
      className={classes(classNames.customFooter, {
        [classNames.customFooter__colorFooter]: !fromLogin,
        [classNames.customFooter__noSticky]: disableSticky,
        [className || '']: !!className,
      })}
    >
      <div className={classNames.customFooter__icons}>
        <SVG className={classNames.customFooter__icon} src={iconBritannica} />
      </div>
      <div className={classNames.customFooter__centerBlock}>
        <ul className={classNames.customFooter__list}>
          {LinkList.sort((a, b) => a.order - b.order).map(link => (
            <li key={link.order} className={classNames.customFooter__item}>
              <a
                href={link.path}
                target='_blank'
                rel='noopener noreferrer'
                className={classNames.customFooter__link}
              >
                {link.name}
              </a>
            </li>
          ))}
        </ul>

        <div className={classNames.customFooter__copyright}>
          <img className={classNames.customFooter__copyrightIcon} src={copyright} />
          {t('copyright')}
        </div>
      </div>
      <StoreButtons />
    </div>
  );
};

export default Footer;
